import { createAction, props } from '@ngrx/store';
import { RestApiError } from 'src/app/common-components/errors/models/error-message';
import { ApplicationLogin } from '../models/application-login.interface';
import { LoginDetails } from '../models/login-details.model';

export const login = createAction('[Login] Attempt Login', props<LoginDetails>());

export const ssoLogin = createAction('[Login] Attempt SSO Login', props<{ fromDialog: boolean }>());

export const ssoLoginSuccess = createAction('[Login] SSO Login Success', props<{ fromDialog: boolean }>());

export const ssoLoginTimeout = createAction('[Login] SSO Login Timeout');

export const ssoLoginFailure = createAction('[Login] SSO Login Failure');

export const loginSuccess = createAction(
   '[Login] Login Success',
   props<{ loginResult: ApplicationLogin; fromDialog?: boolean }>()
);

export const loginFailure = createAction('[Login] Login Failure', props<RestApiError>());

export const logout = createAction('[Top Bar] Logout');

export const apiLogout = createAction('[Logout] Logout API Call');

export const apiLogoutSuccess = createAction('[API] Logout Success');

export const apiLogoutFailure = createAction('[API] Logout Failure', props<RestApiError>());

export const authenticationGuardBlockedRoute = createAction(
   '[Authentication Guard] Authentication Guard Blocked Route',
   props<{ url: string }>()
);

export const reAuthenticationRequired = createAction('[Auth Interceptor] Re-Authentication Required');

export const reAuthenticate = createAction('[Login Dialog] Attempt Re-Authentication', props<LoginDetails>());

export const reAuthenticationSuccess = createAction(
   '[Login Dialog] Re-Authentication Success',
   props<{ loginResult: ApplicationLogin }>()
);

export const reAuthenticationFailure = createAction('[Login Dialog] Re-Authentication Failure', props<RestApiError>());

export const reAuthenticationCancel = createAction('[Login Dialog] Re-Authentication Cancel');

export const updateIsSystemUser = createAction(
   '[Authentication] Update Is System User',
   props<{ isSystemUser: boolean }>()
);
